export default __webpack_public_path__ + "static/media/testimony1.89645ff7.jpg";